module.exports = __webpack_public_path__ + "static/media/mode-55.2e0e4fdc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-55.svg
// module id = 1027
// module chunks = 2